import { keys } from 'app/config/keys';

import { BaseClientConstructorProps } from './generated/baseClient';
import { setLastInteractionTimestamp } from '../cookie';
import { applyCurrencyTypeId } from '../utils';

export const baseClientConstructorProps: BaseClientConstructorProps = {
  apiKey: keys.API_KEY,
  apiSecret: keys.API_SECRET,
  baseUrl: keys.API_URL,
  bypassGateway: keys.BYPASS_GATEWAY,
  gatewayKey: keys.GATEWAY_KEY,
  nodeEnvironment: keys.NODE_ENV,
  onApplyCurrencyTypeId: applyCurrencyTypeId,
  onUpdateLatestInteractionTimestamp: setLastInteractionTimestamp,
};
